<div class="flex items-center h-12">
  @if (view() === 'month') {
    <button
      (click)="navigate('years', -1)"
      [disabled]="prevYearDisabled()"
      matIconButton
    >
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
    <button
      (click)="navigate('months', -1)"
      [disabled]="prevMonthDisabled()"
      matIconButton
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
  }

  <button
    class="mx-auto"
    (click)="toggleYearView()"
    matButton
  >
    {{ left.activeDate | date:'MMM yyyy' }} - {{ right.activeDate | date:'MMM yyyy' }}
    <mat-icon iconPositionEnd>
      {{ view() === 'month' ? 'arrow_drop_down' : 'arrow_drop_up' }}
    </mat-icon>
  </button>

  @if (view() === 'month') {
    <button
      (click)="navigate('months', 1)"
      [disabled]="nextMonthDisabled()"
      matIconButton
    >
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <button
      (click)="navigate('years', 1)"
      [disabled]="nextYearDisabled()"
      matIconButton
    >
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
  }
</div>

<div
  class="grid grid-cols-2"
  [class.hidden]="view() !== 'month'"
>
  <mat-calendar
    (selectedChange)="onDateSelected($event)"
    [maxDate]="maxDate()"
    [minDate]="minDate()"
    [selected]="range()"
    [startAt]="startAt()"
    #left
  />
  <mat-calendar
    (selectedChange)="onDateSelected($event)"
    [maxDate]="maxDate()"
    [minDate]="minDate()"
    [selected]="range()"
    [startAt]="endAt()"
    #right
  />
</div>

@if (view() === 'multi-year') {
  <mat-calendar
    class="multi-year"
    (monthSelected)="onMonthSelected($event)"
    [maxDate]="maxDate()"
    [minDate]="minDate()"
    [startView]="view()"
  />
}
